import { AppBarGuardType, AppBarGuardObjectType } from '../type';

export const name = 'isTargetClosed';

export const fn: AppBarGuardType = (context) => context.target === 'closed';

export const guard: AppBarGuardObjectType = {
  [name]: fn,
};

export default guard;
